import gql from 'graphql-tag'

export default gql`

mutation editProjectInvoicePrefix($project_id: String!, $client_id: Int!, $invoice_prefix: String!) {
    editProjectInvoicePrefix(project_id: $project_id, client_id: $client_id, invoice_prefix: $invoice_prefix) @client
}`